module.exports = __webpack_public_path__ + "static/media/pointx.539dfed1.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/pointx.png
// module id = 455
// module chunks = 0